import React from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Button, Box } from '@mui/material';

interface AddUserButtonProps {
  onClick: () => void; // Explicitly define the type of onClick prop
}

const AddUserButton: React.FC<AddUserButtonProps> = ({ onClick }) => {
  return (
    <Button
      size="small"
      variant="contained"
      startIcon={<AddRoundedIcon />}
      onClick={onClick}
    >
      Add User
    </Button>
  );
};

export default AddUserButton;
